<template>
  <main>
    <v-dialog v-model="deleteDialog" v-if="currentCommonQuestions" max-width="600">
      <DeleteModal
          title="Deletar"
          :textMessage="`Tem certeza que quer remover a pergunta: ${currentCommonQuestions.question}?`"
          cancelBtn="Cancelar"
          okbtn="Remover"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(deleteDialog = false)"
          @action="remove"
      />
    </v-dialog>

    <Header
        buttonTitle="Cadastrar pergunta"
        title="Perguntas Frequentes"
        text="Perguntas Frequentes"
        @action2="goToRoute('/perguntasFrequentesCadastrar')"
        :haveAction="false"
        :haveBack="false"
        :haveCustomButton="true"
    />

    <v-card class="mx-2">
      <v-row cols="12">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :loading="loading"
              :items="commonQuestions"
              class="content-table"
              loading-text="Buscando..."
              no-data-text="Sem registros"
              hide-default-footer
          >
            <template v-slot:[`item.actions`]="{ item }">
              <div style="display: flex; flex-direction: row; flex-wrap: nowrap">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px"
                        width="35"
                        height="35"
                        small
                        class="ma-1 table-button"
                        color="quaternary"
                        @click="editCommonQuestions(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px"
                        width="35"
                        height="35"
                        small
                        class="ma-1 remove-button"
                        color="red"
                        @click="deleteCommonQuestions(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="totalItems > filter.pageSize"
                    :currentPage="currentPage"
                    :totalItems="totalItems"
                    :page="filter.page"
                    :pageSize="filter.pageSize"
                    :totalPages="filter.totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </main>
</template>

<script lang="js">
import ApiService from '../../../services/ApiService';
import Header from "./components/Header";
import Utils from "../../../Utils/FormatDate";
import DeleteModal from "../components/DeleteModal";
import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "CommonQuestions",
  components: {
    Pagination,
    Header,
    DeleteModal
  },
  created() {

  },
  async mounted() {
    try {
      await this.list()
    } catch (e) {

    }
  },
  data() {
    return {
      loading: false,
      apiService: new ApiService(),
      currentPage: 1,
      totalItems: 1,
      filter: {
        search: '',
        pageSize: 15,
        page: 1,
        totalPages: 1,
      },
      headers: [
        {
          text: "Pergunta",
          value: "question",
          sortable: false,
          align: "center",
        },
        {
          text: "Resposta",
          value: "answer",
          sortable: false,
          align: "center",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      commonQuestions: [],
      currentCommonQuestions: null,
      deleteDialog: false,
      status: [
        {label: "Inativo", value: false},
        {label: "Ativo", value: true},
      ],
    }
  },

  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },

    async list() {
      this.loading = true;
      this.apiService.post('commonQuestions/all', this.filter).then((response) => {
        const {content} = response
        this.commonQuestions = content.commonQuestions
        this.filter.totalPages = content.pager.totalPages
        this.totalItems = content.pager.totalItems;
        this.currentPage = content.pager.currentPage;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },

    async backPage() {
      this.filter.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.list();
    },

    async editCommonQuestions(item) {
      localStorage.setItem("filters", JSON.stringify(this.filter));
      await this.$router.push({
        path: "/perguntasFrequentesCadastrar?id=" + item.id,
        params: item,
      });
    },

    deleteCommonQuestions(item) {
      this.currentCommonQuestions = item;
      this.deleteDialog = true;
    },

    async remove() {
      this.loading = true;
      this.deleteDialog = false;
      this.apiService.delete(`commonQuestions/${this.currentCommonQuestions.id}`)
          .then(async () => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "sucsess",
              title: "",
              message: "Pergunta excluida com sucesso!",
              trace: null,
            });
            await this.list();
          })
          .catch((err) => {
            console.error(err)
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Não foi possível excluir pergunta, verifique os campos e tente novamente!",
              trace: null,
            });
            this.loading = false;
          });
    },
  },

  watch: { }
};
</script>

<style scoped>
.update-status {
  width: 110px !important;
  border-radius: 2px !important;
}

</style>
